class CatFilterManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }

    run() {
        document.querySelectorAll('[data-cat-filter]').forEach(el => {
            new CatFilter(el, this)
        })
    }
}

class CatFilter {
    constructor(el, parent) {
        this.el = el
        this.parent = parent

        this.run()
    }

    run() {
        this.set(0)
        this.el.addEventListener('change', (ev) => {
            this.update()
        })
        setTimeout(() => {
            this.update()
        }, 100)
    }

    update() {
        const idx = this.el.selectedIndex
        this.set(idx)
    }

    set(idx) {
        const id = this.el.options[idx].value
        this.hideAll()
        this.show(id)
    }

    hideAll() {
        document.querySelectorAll('[data-cat-filter-id]').forEach(el => {
            el.style.display = 'none'
        })
    }

    show(id) {
        document.querySelectorAll('[data-cat-filter-id="'+id+'"]').forEach(el => {
            el.style.display = ''
        })
    }
}

export default CatFilterManager